module.exports = __webpack_public_path__ + "static/media/word-elimination.7a66e2b1.svg";